var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_250x250",
    "data-name": "250x250",
    width: 61,
    height: 61,
    rx: 30.5,
    transform: "translate(6 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_Travel_Outline_Location_Globe",
    "data-name": "Icon/Travel/Outline/Location/Globe",
    transform: "translate(22.5 22.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(2.333 2.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M11.614,23.333a11.667,11.667,0,1,1,.105,0h-.105ZM8.773,20.541a16.26,16.26,0,0,1-2.867-7.708h-3.5A9.361,9.361,0,0,0,8.773,20.541Zm5.791,0a9.361,9.361,0,0,0,6.364-7.707h-3.5A16.166,16.166,0,0,1,14.563,20.54ZM11.6,20.383l.07.08.07-.08a13.93,13.93,0,0,0,3.354-7.549H8.247A13.942,13.942,0,0,0,11.6,20.383ZM20.927,10.5A9.362,9.362,0,0,0,14.56,2.792,16.263,16.263,0,0,1,17.428,10.5Zm-5.84,0a13.933,13.933,0,0,0-3.35-7.549l-.071-.081-.069.081A14.108,14.108,0,0,0,8.245,10.5ZM5.9,10.5A16.165,16.165,0,0,1,8.77,2.793,9.361,9.361,0,0,0,2.406,10.5Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteDefault);
export default __webpack_public_path__ + "static/media/website-default.5d69b2005b8a49f6771399e86f4c0666.svg";
export { ForwardRef as ReactComponent };